export default __webpack_public_path__ + "c3ae4efd65c3f02d2a6a1c92f2638379.ico";